/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// Search form
document.querySelector("#headerIconsSearchButton").addEventListener("click", function () {
    document.querySelector("#headerIconsSearch").classList.toggle("active");
    document.querySelector("#headerIconsSearchButton").classList.toggle("active");
    document.querySelector("#headerIconsSearchButtonClose").classList.toggle("active");
    document.querySelector("#headerIconsSearchForm input").focus();
});

document.querySelector("#headerIconsSearchButtonClose").addEventListener("click", function () {
    document.querySelector("#headerIconsSearch").classList.toggle("active");
    document.querySelector("#headerIconsSearchButton").classList.toggle("active");
    document.querySelector("#headerIconsSearchButtonClose").classList.toggle("active");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));